import { all, call, select, put, takeLatest } from "redux-saga/effects";
import { helpers, http } from "../../common/lib";
import config from "../../config";
import { actionCreators, actionTypes } from "./actions";
import { logToSentry } from "../../config/Sentry";

const reducer = (aggregate: any, [key, value]: any) => ({
    ...aggregate,
    [key]: helpers.getListReducer({}, value)
});

function* getRequest() {
    try {
        const { id } = yield select((state) => state.userOrganisations.item);
        const res = yield call(
            http.authorized.get,
            `${config.api.paths.typesList}?organisation=${id}&source=1`
        );
        const data = Object.entries(res.data).reduce(reducer, {});
        yield put(actionCreators.getSuccess(data));
    } catch (error) {
        logToSentry("On types list get:", { error });
        yield put(actionCreators.getFailure(error));
    }
}

export default function* () {
    yield all([takeLatest(actionTypes.TYPES_LIST_GET_REQUEST, getRequest)]);
}
